import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import { useContext } from "react";
import { useTranslate } from "react-admin";
import { AppContext } from "../../shared/context/AppContext";
import useUserContext from "../../shared/useUserContext";

const useStyles = makeStyles({
  loggedInMsg: {
    marginLeft: "auto",
    fontSize: "14px",
  },
});

export const getOrgName = (prefix, userContext) => {
  if (userContext.isInternal) {
    return prefix + "Transpower";
  }

  const externalOrgName = userContext.orgPermission?.orgName;

  if (externalOrgName) {
    return prefix + externalOrgName;
  }

  return null;
};

export const FixedOrgDisplay = (props: any) => {
  const translate = useTranslate();
  const userContext = useUserContext();
  const classes = useStyles();

  const appContext = useContext(AppContext);

  if (appContext?.appname) {
    return (
      <Typography
        id="react-admin-logged-in-user"
        className={classes.loggedInMsg}
      >
        {translate(appContext.appname)}
        {getOrgName(" - ", userContext)}
      </Typography>
    );
  } else {
    return null;
  }
};
